export var URL_DATA = {
  ORGANIZATION: 'orgDetails',
  TREE_DATA: 'treeData',
  STORYBOARD_TREEDATA: 'storyboardTreeData',
  PROJECT_DETAILS: 'projectDetails',
  DASHBOARD_FILTER: 'dashboardFilter',
  STORYBOARD_FILTER: 'storyBoardFilter',
  SHOW_STORYBOARD: 'showStoryboard'
};
export var STAKE_HOLDER_URL = {
  DEVELOPMENT: "https://stakeholder.dev.culturebie.com",
  STAGING: "https://stakeholder.qa.culturebie.com",
  PRODUCTION: "https://stakeholder.app.culturebie.com",
  LOCAL: "http://localhost:5173"
};
export var STAKEHOLDER_SUBROUTE = {
  ADMIN_SETUP: "/admin-setup/"
};